import React from "react";
import * as Funciones from "../../../../utils/funciones";
import styles from "./tabla-proyecciones-vi.module.css";

const TablaProyeccionesVI = ({ proyecciones, moneda }) => {
    return (
        <div className={styles.contenedor}>
            <div className={styles.gridHeader}>
                <div className={styles.ghEdad}>
                    Edad
                </div>
                <div className={styles.ghMontoPagado}>
                    Monto pagado
                </div>
                <div className={styles.ghCargosSeguro}>
                    Cargos del seguro
                    <sup className={styles.sup}>(2)</sup>
                </div>
                <div className={styles.ghSumaAsegurada}>
                    Suma asegurada
                </div>
                <div className={styles.ghSaldoIndividual}>
                    Saldo cuenta individual
                    <sup className={styles.sup}>(3)</sup>
                </div>
                <div className={styles.ghSaldoExcedentes}>
                    Saldo cuenta excedentes
                    <sup className={styles.sup}>(4)</sup>
                </div>
                <div className={styles.ghSaldoCuentas}>
                    Saldo total cuentas
                </div>
                <div className={styles.ghValorRescate}>
                    Valor de rescate
                    <sup className={styles.sup}>(5)</sup>
                </div>
            </div>
            
            <div className={styles.body}>
                {proyecciones !== undefined && proyecciones.length > 0
                    ? Funciones.ordenarListaXCampo(true, proyecciones, 'anio').map((proyeccion, index) => (
                        <div key={'proyeccion_' + index} className={styles.gridBody}>
                            <div className={styles.gbEdad}>
                                {proyeccion.edad}
                            </div>
                            <div className={styles.gbMontoPagado}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.montoPagado, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbCargosSeguro}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.cargosSeguro, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbSumaAsegurada}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.sumaAseguradaBase, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbSaldoIndividual}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.saldoCuentaIndividual, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbSaldoExcedentes}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.saldoCuentaExcedente, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbSaldoCuentas}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.saldoCuentaConsolidada, moneda.codigo, true)}
                            </div>
                            <div className={styles.gbValorRescate}>
                                {Funciones.mostrarFormatoMoneda(proyeccion.valorRescate, moneda.codigo, true)}
                            </div>
                        </div>
                    ))
                    : <div className={styles.label_no_data}>
                        <div className={styles.label_no_data_span}>No se encontraron registros.</div>
                    </div>
                }
            </div>
        </div>
    )
}

export default TablaProyeccionesVI;